import React, { Component } from "react";
import {
  Grid,
  Button,
  Typography,
  Hidden
} from "@material-ui/core";
import Parser from "html-react-parser";
import moment from "moment";
import { ThumbUpOutlined } from "@material-ui/icons";
import { primaryColor, textBlack, textGrey, webFont } from "../../config/theme";
import './style.css';

const defaultImg = "/images/orange-logo-white-bg.webp";

export default class SinglePost extends Component {
  state = {
    numOfLikes: 0
  };

  render() {
    const { numOfLikes } = this.state;
    const { post, index, page, handleClick, viewAsDiner } = this.props;

    const bodyLength = post.body ? post.body.length : 0;

    let postImg = defaultImg;
    if (post.media) {
      if (post.media.length > 0) {
        const length = post.media.length;
        const index = post.media.findIndex(item => item.size === "MEDIUM");
        if (index < 0) {
          postImg = post.media[length - 1].url;
        } else {
          postImg = post.media[index].url;
        }
      }
    }

    const createdAt = post.createdAt / 1000;
    const postDate = moment.unix(createdAt).format("DD MMM");

    return (
      <>
        <div className="post-box-container" key={post.id + "post"} data-test-id={"chefpostlist"} onClick={() => this.props.handleClick(post)}>
          <div className="post-dish-name">
            <Typography variant="h6" style={style.setFont} noWrap={true}>
              {post.title}
            </Typography>
          </div>
          <div className="post-image">
            <img src={postImg} alt={post.title} title={post.title} style={{ opacity: post.isDraft ? 0.6 : 1 }} />
          </div>
          <div className="post-description">
            <Typography
              variant="subtitle1"
              color="textSecondary"
              style={{ ...style.setFont, ...style.postDesc }}
            >
              {bodyLength > 150
                ? Parser(post.body.substr(0, 150))
                : Parser(post.body)}
            </Typography>
          </div>
          <div className="post-bootom-detail">
            <Typography
              variant="subtitle1"
              style={{
                ...style.setFont,
                ...style.byFont,
                margin: 0,
              }}
            >
              By: {post.chefName}
            </Typography>
            <Typography
              variant="subtitle1"
              color="textSecondary"
              style={{
                ...style.setFont,
                fontSize: 12,
                color: '#444444',
                opacity: '0.35',
                margin: 0,
              }}
            >
              on {postDate}
            </Typography>
          </div>
          {!viewAsDiner && this.props.isChef && <Grid item xs={5} sm={5} md={3} style={{padding: 0}}>
                <Button
                  disableRipple={true}
                  disableFocusRipple={true}
                  disableTouchRipple={true}
                  style={{
                    ...style.setFont,
                    color: primaryColor,
                    fontSize: 14,
                    backgroundColor: "transparent",
                    boxShadow: 'none',
                    padding: 0,
                    margin: 0,
                    textTransform: 'lowercase',
                    minWidth: 'auto'
                  }}
                  size={"small"}
                  variant={"contained"}
                >
                  {post.numOfLikes ? `  ${post.numOfLikes}` : `  ${numOfLikes}`} like(s)
                  {/*<ThumbUpOutlined
                    fontSize={"small"}
                    style={{ marginLeft: 8 }}
                  />*/}
                </Button>
              </Grid>}
        </div>
      </>
    );
  }
}

const style = {
  avatarImg: {
    width: 101,
    height: 101,
    borderRadius: 0
  },
  ftGrid: {
    marginTop: 40,
    marginBottom: 10
  },
  ftText: {
    fontFamily: webFont,
    color: textBlack,
    marginLeft: 80,
    weight: 800,
    marginBottom: 30,
    marginTop: 30
  },
  chefName: {
    fontFamily: webFont,
    color: textBlack,
    weight: 500,
    paddingLeft: 25
  },
  chefCuisine: {
    fontFamily: webFont,
    color: textGrey,
    weight: 500,
    maxWidth: 400,
    paddingLeft: 25
  },
  featuredItem: {
    marginTop: 20,
    marginBottom: 10
  },
  showBtn: {
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20
  },
  card: {
    //display: "flex"
  },
  details: {
    display: "flex",
    flexDirection: "column"
  },
  content: {
    flex: "1 0 auto"
  },
  cover: {
    width: 151
  },
  setFont: {
    fontFamily: webFont,
    color: '#444444',
    marginBottom: 12,
    lineHeight: 'normal',
  },
  byFont: {
    fontFamily: webFont,
    color: 'rgba(0, 0, 0, 0.87)',
    lineHeight: 'normal',
    fontWeight: 500,
    padding: 0
  },
  littleHeavy: {
    fontWeight: 500
  },
  moveRight: {
    marginLeft: 10,
    paddingTop: 5,
    paddingBottom: 5
  },
  postDesc: {
    height: 70,
    overflow: "hidden",
    fontSize: 15,
    color: '#979797',
    paddingRight: 18,
  },
  postTitle: {
    height: 50,
    overflow: "hidden"
  }
};
